module.exports = __webpack_public_path__ + "img/buy_normal_cn.d80d596e.png";